<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12f0q1B/media/FC-9781398458086.jpg?1718046516752" alt="This image is the cover for the book Tederederies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tederederies
      </h1>
      <p class="bookDescription body article font2">
        <p>Everyone supports Fanny Williams as little Renny becomes part of the Aberbryncraig story and causes a problem or two on his way, showing considerable ingenuity and originality. Mrs Mopalot sorts it all out again with the help of those who have caused all the difficulties, her husband, cocoa in bed, and above all, most of the population of Aberbryncraig in one way or another. The Summer Party is rather unusual this year.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P. A. Gillis
      </h2>
      
      <p class="authorDescription body article">P. A. Gillis has written stories, plays and poems all her life. She performs her poems at clubs and poetry gatherings, and inserts them on ‘Poems Tuppence Each’. She has had a play professionally produced and another given a rehearsed reading at a festival, two poems in an anthology and The Great Neptune Bar Mystery published in 2020, hopefully cheering people during and after the pandemic. The Great Saint Controversy is being written now.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f0ca850